<template>
  <v-dialog
      v-model="dialog"
      fullscreen
  >
    <v-card>
      <v-card-title>
        {{ orderNumber ? 'Sipariş Detay #' + orderNumber : 'Sipariş Numarası Tanımlı Değil' }}
        <v-spacer></v-spacer>
        <v-btn @click="dialog = false" color="danger darken-1" style="color: white;">
          KAPAT
        </v-btn>
      </v-card-title>
      <v-card-text v-if="orderNumber" id="printDiv">
        <div>

        </div>
        <div class="mb-4 d-flex justify-content-between">
          <img
              :src="logoFromConfig()"
              alt="logo"
              height="40"
          />
          <div class="d-flex flex-column">
            <div><b>Tarih : </b> {{ formattedDate(orderInfo.date, "DD-MM-YYYY HH:mm") }}</div>
            <div><b>Sipariş No : </b> {{ orderInfo.orderNumber }}</div>
            <!--            <div>-->
            <!--              <v-btn @click="openCurrentUnclosedInvoicesDialog" color="amber darken-4" class="exclude-print" small text-->
            <!--                     depressed ripple>-->
            <!--                <v-icon left>mdi-file-document-alert</v-icon>-->
            <!--                Kapatılmamış Faturalar-->
            <!--              </v-btn>-->
            <!--            </div>-->
          </div>
        </div>
        <div class="mb-4 d-flex justify-content-start py-5">
          <div class="d-flex w-100 flex-column ps-4"
               style="font-size:12px;border-left: 5px solid grey;border-bottom: 5px solid grey">
            <div class="py-3"><b>Cari Kodu : </b> {{ orderInfo.currentCode }}</div>

            <div class="py-3"><b>Cari Adı : </b> {{ orderInfo.currentName }}</div>

            <div class="py-3"><b>Cari Adres : </b>{{ orderCurrent?.address }}</div>

            <div class="py-3"><b>İl / İlçe : </b>{{ orderCurrent?.city +  "/" + orderCurrent?.town }}</div>


            <div class="py-3"><b>Plasiyer : </b> {{ orderInfo.salesPersonCode + ' - ' + orderInfo.salesPersonName }}
            </div>
            <div v-if="erpSettings.cartProjectProcess === true" class="py-3"><b>Proje Kodu : </b>
              {{ orderInfo.projectCode }}
            </div>
            <div v-if="erpSettings.cartProjectProcess === true" class="py-3"><b>Proje Açıklaması : </b>
              {{ orderProject?.description }}
            </div>
            <div class="py-3"><b>Sipariş Açıklaması : </b>
              {{ orderInfo?.description }}
            </div>
          </div>
        </div>
        <div class="p-2 mt-3">
          <h3 class="font-size-16 text-center">Sipariş Özeti</h3>
          <hr>
        </div>
        <b-table
            small
            class="table table-sm"
            :items="orderInfo.orderDetails"
            :fields="erpSettings.netsisCurrencySale ? orderInfoTableHeadersCurr : orderInfoTableHeaders"
            hover
            responsive
            :per-page="0"
            style="font-size:12px"
            head-row-variant="info"
            table-variant="white"
            id="printOrders"
        >
          <template #table-busy>
            <div class="text-center">
              <b-spinner
                  variant="primary"
                  size="lg"
              ></b-spinner>
            </div>
          </template>
          <template #cell(currencyUnitPrice)="data">
            <span>{{ numberConverter(data.item.currencyUnitPrice) + fetchCurrencyLabel(orderCurrencyType) }}</span>
          </template>
          <template #cell(currencyNetPrice)="data">
            <span>{{ (data.item.currencyNetPrice) + fetchCurrencyLabel(orderCurrencyType) }}</span>
          </template>
          <template #cell(currencyAmount)="data">
            <span>{{ numberConverter(data.item.currencyAmount) + fetchCurrencyLabel(orderCurrencyType) }}</span>
          </template>
          <template #cell(discount1)="data">
            <span>{{ data.item.discount1 + ' %' }}</span>
          </template>
          <template #cell(discount2)="data">
            <span>{{ data.item.discount2 + ' %' }}</span>
          </template>
        </b-table>
        <div class="">
          <div class="row" style="justify-content: space-between">
            <div class="col-lg-6">
              <h5 class="">Sipariş Notu : </h5>
                <v-text-field
                    readonly
                    v-model="orderInfo.description"
                    dense
                    flat
                    solo
                    rows="3"
                ></v-text-field>
              <h5 class="text-start">Teslimat Tarihi</h5>
              <div class="d-inline-flex align-items-center">
                <v-menu
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        style="align-self: center"
                        :disabled="userRoleId !== '1'"
                        :value="formattedDate(deliveryDate,'DD MMMM YYYY')"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        filled
                        solo
                        dense
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="deliveryDate"
                      locale="tr"
                  ></v-date-picker>
                </v-menu>
                <v-btn class="d-print-none" color="success darken-1 mb-6 ml-6" v-if="userRoleId === '1'" style="color: white; " @click="_updateOrderDeliveryDate" >Güncelle</v-btn>
              </div>
              </div>
            <div class="col-lg-4 table-responsive pagebreak">
              <table class="table table-sm mb-0">
                <tbody>
                <tr>
                  <td>Brüt Tutar</td>
                  <td style="text-align: right">{{ numberConverter(orderInfo.grossAmount) }} ₺</td>
                </tr>
                <tr>
                  <td>İskonto</td>
                  <td style="text-align: right">{{ numberConverter(orderInfo.discount) }} ₺</td>
                </tr>
                <tr>
                  <td>Ara Toplam</td>
                  <td style="text-align: right">{{ numberConverter(orderInfo.subTotal) }} ₺</td>
                </tr>
                <tr>
                  <td>KDV</td>
                  <td style="text-align: right">{{ numberConverter(orderInfo.vat) }} ₺</td>
                </tr>
                <tr>
                  <th>Toplam Tutar :</th>
                  <th style="text-align: right">{{ numberConverter(orderInfo.totalAmount) }} ₺</th>
                </tr>
                </tbody>
              </table>
              <hr>
              <div class="" v-if="erpSettings.netsisCurrencySale">
                <div class="table-responsive">
                  <table class="table table-sm mb-0">
                    <tbody>
                    <tr>
                      <td>Dövizli Brüt Tutar</td>
                      <td style="text-align: right">{{ numberConverter(orderInfo.currencyGrossAmount) + fetchCurrencyLabel(orderCurrencyType) }}</td>
                    </tr>
                    <tr>
                      <td>Dövizli İskonto</td>
                      <td style="text-align: right">{{ numberConverter(orderInfo.currencyDiscount) + fetchCurrencyLabel(orderCurrencyType) }}</td>
                    </tr>
                    <tr>
                      <td>Dövizli Ara Toplam</td>
                      <td style="text-align: right">{{ numberConverter(orderInfo.currencySubTotal) + fetchCurrencyLabel(orderCurrencyType) }}</td>
                    </tr>
                    <tr>
                      <td>Dövizli KDV</td>
                      <td style="text-align: right">{{ numberConverter(orderInfo.currencyVat) + fetchCurrencyLabel(orderCurrencyType) }}</td>
                    </tr>
                    <tr>
                      <th>Dövizli Toplam Tutar</th>
                      <th style="text-align: right">{{ numberConverter(orderInfo.currencyTotalAmount) + fetchCurrencyLabel(orderCurrencyType) }}</th>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="d-flex justify-content-center ">
          <div class="exclude-print mt-4">
            <v-btn v-if="(userRoleId=== '1' || userRoleId === 1) && orderInfo.status !==2"
                   class="mx-2" text color="success darken-1" @click="_approveOrder">
              <v-icon left>mdi-check-decagram</v-icon>
              Onayla
            </v-btn>
            <ExcelExport
                :dataProp="orderInfo.orderDetails"
                :column-prop="erpSettings.netsisCurrencySale ? orderInfoTableHeadersCurr : orderInfoTableHeaders"
                :fileNameProp="'Cari Kodu : ' + orderInfo.currentCode + ' Sipariş Numarası :' + orderInfo.orderNumber "
            >

            </ExcelExport>
            <PrintPage :divId="'printDiv'"></PrintPage>
            <v-btn @click="dialog = false" class="mx-2 text-white" text color="danger darken-1">
              <v-icon left>mdi-close</v-icon>
              Kapat
            </v-btn>
          </div>

        </div>

      </v-card-text>

    </v-card>
    <CurrentUnclosedInvoicesDialog :showDialog="showCurrentUnclosedInvoicesDialog"
                                   :currentProp="currentUnclosedInvoicesProp"
                                   @dialogChange="data => showCurrentUnclosedInvoicesDialog = data">

    </CurrentUnclosedInvoicesDialog>
    <StockActionsDialog
        :showDialog="showStockActionsDialog"
        :stockCodeProp="stockCodeProp"
        :currentCodeProp="currentCodeProp"
        @dialogChange="e => (showStockActionsDialog = e)"
    >
    </StockActionsDialog>
    <ProductDetail
        :stock-code="productDetailStockCode"
        :showDialog="showProductDetailDialog"
        @dialogChange="e => (showProductDetailDialog = e)"
    ></ProductDetail>
  </v-dialog>
</template>
<script>

import PrintPage from "@/components/shared/PrintPage";
import {mapActions, mapGetters, mapState} from "vuex";
import CurrentUnclosedInvoicesDialog from "@/components/current/dialogs/CurrentUnclosedInvoicesDialog";
import {formattedDate} from "@/momentHelper";
import {addBase64Prefix, logoFromConfig} from "@/base64Helper";
import {numberConverter} from "../../../../../helpers";
import StockActionsDialog from "@/components/product-search/dialogs/StockActionsDialog.vue";
import ProductDetail from "@/pages/views/product/ProductDetail.vue";
import ExcelExport from "@/components/shared/ExcelExport.vue";


export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    orderNumber: {
      type: String,
      default: null
    },
    orderId: {
      type: Number,
      default: 0
    },
    orderCurrentCode: {
      type: String,
      default: "",
    },
    orderCurrencyType: {
      type: Number,
      default: 0
    }
  },
  components: {
    ExcelExport,
    ProductDetail,
    StockActionsDialog,
    PrintPage,
    CurrentUnclosedInvoicesDialog
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("settings", ["erpSettings"]),
    ...mapGetters("settings", ["getCurrencyLabels"]),
    currencyLabels: {
      get() {
        return this.getCurrencyLabels;
      },
    },
  },
  data() {
    return {
      orderCurrent: null,
      userRoleId: this.$store.state.auth.user.RoleGroupId,
      dialog: false,
      productDetailStockCode: null,
      showStockActionsDialog: false,
      showProductDetailDialog: false,
      stockCodeProp: null,
      currentCodeProp: null,
      currentUnclosedInvoicesProp: null,
      showCurrentUnclosedInvoicesDialog: false,
      orderProject: null,
      orderInfo: {
        orderDetails: []
      },
      orderInfoTableHeaders: [],
      orderInfoTableHeadersCurr: [],
      deliveryDate: null,
    }

  },
  methods: {
    numberConverter,
    addBase64Prefix,
    fetchCurrencyLabel(currencyType) {
      for (const item of this.currencyLabels) {
        if (item.id === currencyType) {
          return item.label;
        }
      }
      return '';
    },
    logoFromConfig() {
      return logoFromConfig
    },
    formattedDate,
    ...mapActions("order", ["fetchSingleOrder", "approveOrder","updateOrderDeliveryDate"]),
    ...mapActions("current", ["fetchSingleCurrent"]),
    ...mapActions("project", ["fetchSingleProjectByCode"]),
    async _fetchSingleOrder() {
      this.deliveryDate = null;
      this.orderInfo = await this.fetchSingleOrder({
        params: {},
        body: {},
        urlSegments: [this.orderId]
      })
      this.orderInfo.orderDetails.map((item) => (item.netPrice = this.numberConverter((((item.amount) - (item.discountAmount1 + item.discountAmount2)) / item.quantity)) + " ₺"));
      this.orderInfo.orderDetails.map((item) => (item.currencyNetPrice = this.numberConverter((((item.currencyAmount) - (item.currencyDiscountAmount1 + item.currencyDiscountAmount2)) / item.quantity))));
      this.orderInfo.orderDetails.map((item) => (item.unitPrice = this.numberConverter(item.unitPrice) + " ₺"));
      this.orderInfo.orderDetails.map((item) => (item.amount = this.numberConverter(item.amount) + " ₺"));
      if (this.orderInfo.deliveryDate) this.deliveryDate = this.orderInfo.deliveryDate.split('T')[0];
      if (this.orderInfo.projectCode) {
        await this._fetchSingleProject();
      }
      this.orderInfoTableHeaders = [
        {
          key: 'stockCode',
          label: 'Stok Kodu',
          sortable: false,
          class: 'text-center align-middle'
        },
        {
          key: 'stockName',
          label: 'Stok Adı',
          sortable: false,
          class: 'text-left align-middle'
        },
        {
          key: 'producerCode',
          label: 'Üretici Kodu',
          sortable: false,
          class: 'text-left align-middle',

        },
        {
          key: 'quantity',
          label: 'Miktar',
          sortable: false,
          class: 'text-center align-middle',
        },
        {
          key: 'unitPrice',
          label: 'Birim Fiyat',
          sortable: false,
          class: 'text-center align-middle',
        },
        {
          key: 'netPrice',
          label: 'Net Fiyat',
          sortable: false,
          class: 'text-center align-middle',
        },
        {
          key: 'discount1',
          label: 'İskonto 1',
          sortable: false,
          class: 'text-center align-middle',
        },
        {
          key: 'discount2',
          label: 'İskonto 2',
          sortable: false,
          class: 'text-center align-middle',
        },
        {
          key: 'amount',
          label: 'Tutar',
          sortable: false,
          class: 'text-center align-middle',
        },
      ];
      this.orderInfoTableHeadersCurr = [
        {
          key: 'stockCode',
          label: 'Stok Kodu',
          sortable: false,
          class: 'text-center align-middle',

        },
        {
          key: 'stockName',
          label: 'Stok Adı',
          sortable: false,
          class: 'text-left align-middle',

        },
        {
          key: 'producerCode',
          label: 'Üretici Kodu',
          sortable: false,
          class: 'text-left align-middle',

        },
        {
          key: 'quantity',
          label: 'Miktar',
          sortable: false,
          class: 'text-center align-middle',
        },
        {
          key: 'unitPrice',
          label: 'Birim Fiyat',
          sortable: false,
          class: 'text-center align-middle',
        },
        {
          key: 'netPrice',
          label: 'Net Fiyat',
          sortable: false,
          class: 'text-center align-middle',
        },
        {
          key: 'currencyUnitPrice',
          label: 'Dövizli Birim Fiyat',
          sortable: false,
          class: 'text-center align-middle',
        },
        {
          key: 'currencyNetPrice',
          label: 'Dövizli Net Fiyat',
          sortable: false,
          class: 'text-center align-middle',
        },
        {
          key: 'discount1',
          label: 'İskonto 1',
          sortable: false,
          class: 'text-center align-middle',
        },
        {
          key: 'discount2',
          label: 'İskonto 2',
          sortable: false,
          class: 'text-center align-middle',
        },
        {
          key: 'amount',
          label: 'Tutar',
          sortable: false,
          class: 'text-center align-middle',
        },
        {
          key: 'currencyAmount',
          label: 'Dövizli Tutar',
          sortable: false,
          class: 'text-center align-middle',
        },
      ]
    },
    async _fetchSingleProject() {
      await this.fetchSingleProjectByCode({
        params: {},
        body: {},
        urlSegments: [this.orderInfo.projectCode]
      }).then((e) => {
        this.orderProject = e
      })
    },
    async _approveOrder() {
      await this.approveOrder({
        params: {},
        body: {},
        urlSegments: [this.orderId]
      });
      this.$parent.$parent._fetchB2BOrders();
      this.dialog = false;
    },
    async _getSingleCurrent() {
      this.orderCurrent = await this.fetchSingleCurrent({
        params: {
          currentCode: this.orderCurrentCode,
        },
        body: {},
      })
    },
    openCurrentUnclosedInvoicesDialog() {
      let tempCurrentUnclosedInvoicesProp = Object.assign(this.orderInfo, {});
      tempCurrentUnclosedInvoicesProp.code = tempCurrentUnclosedInvoicesProp.currentCode;
      tempCurrentUnclosedInvoicesProp.name = tempCurrentUnclosedInvoicesProp.currentName;
      this.currentUnclosedInvoicesProp = tempCurrentUnclosedInvoicesProp;
      this.showCurrentUnclosedInvoicesDialog = true;
    },
    openStockActionListDialog(data) {
      this.stockCodeProp = data.stockCode;
      //this.currentCodeProp = data.currentCode;
      this.showStockActionsDialog = true;
    },
    goProductDetail(stockCode) {
      this.showProductDetailDialog = true;
      this.productDetailStockCode = stockCode;
    },
  async _updateOrderDeliveryDate() {
    await this.updateOrderDeliveryDate({
      params: {
        deliveryDate: this.deliveryDate,
        orderId: this.orderId
      },
      body: {
      },

    })
  },
  },
  watch: {
    "dialog": function (newVal) {
      this.$emit("dialogChange", newVal)
      if (newVal)
        this._getSingleCurrent()
      this._fetchSingleOrder()
    },
    "showDialog": function (newVal) {
      this.dialog = newVal
    },
  }
}
</script>

<style scoped>
.pagebreak {
  @media print {
      clear: both;
      page-break-after: always;
    page-break-before: always;
  }
}
</style>